// extracted by mini-css-extract-plugin
export default {"user-container":"ManageUser_user-container__znxpe","name":"ManageUser_name__4XkK4","delete":"ManageUser_delete__1YdBv"};